//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// Helpers & Constants ---------------------------------------------------------
import { completedRegistration } from '@helpers/account';
import { withAuthUser, deauth } from '@helpers/auth';
import { DoNotSellMyPersonalDataURL } from '@helpers/constants/colgate';
import { Providers as ProvidersRequest } from '@api/endpoints/get/providers';
import { withTranslation } from 'react-i18next';
import { getValue } from '@helpers/localStorage';
import { IsAdminApproved } from '@helpers/constants/localStorage';
//------------------------------------------------------------------------------
// Constants -------------------------------------------------------------------
const MenuSections = [
  {
    className: styles.MainSection,
    items: [
      {
        i18nTitleKey: 'header_Dashboard',
        path: '/recommendations',
        requiresCompleteRegistration: true,
      },
      {
        i18nTitleKey: 'header_RecommendedProducts',
        path: '/',
        requiresCompleteRegistration: true,
      },
    ],
  },
  {
    items: [
      {
        i18nTitleKey: 'header_MyAccount',
        path: '/myaccount',
      },
      {
        i18nTitleKey: 'header_PatientLogin',
        onClick: () =>
          (window.location.href = import.meta.env.VITE_SHOPIFY_PUBLIC_URL),
      },
      { i18nTitleKey: 'header_About', path: '/about' },
      {
        i18nTitleKey: 'header_Logout',
        onClick: () => deauth(),
        requireAuthentication: true,
      },
    ],
  },
  {
    items: [
      {
        i18nTitleKey: 'header_DoNotSellPersonalData',
        externalUrl: DoNotSellMyPersonalDataURL,
      },
    ],
  },
];
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.sectionComponent = this.sectionComponent.bind(this);
  }

  sectionComponent(section, index) {
    const { onClose, __authUser, t } = this.props;

    const sectionClasses = classNames(styles.Section, {
      [section.className]: section.className,
    });

    return (
      <div className={sectionClasses} key={index}>
        {section.items.map((x) => {
          if (x.requireAuthentication && !__authUser) return '';
          if (
            x.requiresCompleteRegistration &&
            !completedRegistration(__authUser)
          )
            return '';

          if (x.path) {
            return (
              <Link
                to={x.path}
                className={styles.Item}
                onClick={onClose}
                key={x.i18nTitleKey}
              >
                {t(x.i18nTitleKey)}
              </Link>
            );
          }

          if (x.onClick) {
            return (
              <span
                className={styles.Item}
                onClick={x.onClick}
                key={x.i18nTitleKey}
              >
                {t(x.i18nTitleKey)}
              </span>
            );
          }

          if (x.externalUrl) {
            return (
              <a
                rel="noopener noreferrer"
                className={styles.Item}
                href={x.externalUrl}
                target="_blank"
                key={x.i18nTitleKey}
              >
                {t(x.i18nTitleKey)}
              </a>
            );
          }

          return '';
        })}
      </div>
    );
  }

  contentComponent() {
    const { location, onClose, t } = this.props;
    const isAdminApproved = getValue(IsAdminApproved, true);
    return (
      <div className={styles.Content}>
        <div className={styles.Sections}>
          {MenuSections.map(this.sectionComponent)}
          {isAdminApproved && (
            <ProvidersRequest>
              {({ data, refetch }) => {
                this.refetch = refetch;

                return (
                  <Link
                    to={{
                      pathname: '/recommendation/professional-code-share',
                      state: { from: location, modal: true },
                    }}
                    onClick={onClose}
                    className={styles.MenuOption}
                  >
                    {t('header_ShareYourCode', {
                      code: data ? data.referralCode : '',
                    })}
                  </Link>
                );
              }}
            </ProvidersRequest>
          )}
        </div>
        <div className={styles.Footer}></div>
      </div>
    );
  }

  render() {
    const { isVisible, onClose, className } = this.props;

    const componentClasses = classNames(styles.Menu, {
      [className]: className,
      [styles.Visible]: isVisible,
    });

    return (
      <div className={componentClasses}>
        <div className={styles.Overlay} onClick={() => onClose()}></div>
        {this.contentComponent()}
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withAuthUser(withTranslation()(Menu));
